"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetCompanyGeneral = class FieldsetCompanyGeneral extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    displayFetchByTaxNumber;
    onDisplay_fetch_by_tax_number(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("displayFetchByTaxNumber");
    }
    companyRelations;
    async $$load_companyRelations() {
        return this.$fn.getEnumValuesFromSchema('CompanyRelation', { sort: false });
    }
    companyGroups;
    async $$load_companyGroups() {
        return this.$fn.fetch('list_group', { parameters: { type: 'company' } })
            .then(data => data.data.map(p => p.name));
    }
    defaultOwnCompanySettings;
    defaultPartnerCompanySettings;
    settings;
    async $$load_settings() {
        return _.extend({}, this.item.role == 'own' ? this.$data.defaultOwnCompanySettings : this.$data.defaultPartnerCompanySettings, this.item.settings);
    }
    ux;
    b_1490259005804208_bindObject;
    dataMembers = ['companyRelations', 'companyGroups', 'defaultOwnCompanySettings', 'defaultPartnerCompanySettings', 'settings', 'ux', 'b_1490259005804208_bindObject'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                companyRelations: null,
                companyGroups: null,
                defaultOwnCompanySettings: {
                    smtp_mail_account_id: null,
                    send_invoice_notifications: false,
                },
                defaultPartnerCompanySettings: {
                    notifications_enabled: null,
                    email_recipients: [],
                    send_invoice_notifications: false,
                },
                settings: null,
                ux: null,
                b_1490259005804208_bindObject: false,
            },
        };
    }
    get isOwnCompany() {
        if (this.loaded) {
            return this.item.role === 'own';
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8497951412896552_emit_7028_getActionArgs($event) {
        return {
            event: "input",
            value: $event.data.response.data,
        };
    }
    async act_8497951412896552_request_7026_getActionArgs($event) {
        return {
            operation: "read_company",
            data: {
                id: this.item.tax_number,
            },
            headers: {
                accept: "application/vnd.itp.taxpayer-info+json",
            },
        };
    }
    async evh_8497951412896552_clickPreventStop(event, scope) {
        return await this.actions.evh_8497951412896552_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2014513287668498_script_7030_getActionArgs_value($event) {
        this.item.settings = this.settings;
    }
    async act_2014513287668498_script_7030_getActionArgs($event) {
        return {
            value: () => this.act_2014513287668498_script_7030_getActionArgs_value($event),
        };
    }
    async evh_2014513287668498_input(event, scope) {
        return await this.actions.evh_2014513287668498_input.executeFromDOM(this, event, scope);
    }
    async act_1490259005804208_script_7032_getActionArgs_value($event) {
        this.item.settings = this.settings;
    }
    async act_1490259005804208_script_7032_getActionArgs($event) {
        return {
            value: () => this.act_1490259005804208_script_7032_getActionArgs_value($event),
        };
    }
    async evh_1490259005804208_input(event, scope) {
        return await this.actions.evh_1490259005804208_input.executeFromDOM(this, event, scope);
    }
    async act_5501809153536538_script_7034_getActionArgs_value($event) {
        this.item.settings = this.settings;
    }
    async act_5501809153536538_script_7034_getActionArgs($event) {
        return {
            value: () => this.act_5501809153536538_script_7034_getActionArgs_value($event),
        };
    }
    async evh_5501809153536538_input(event, scope) {
        return await this.actions.evh_5501809153536538_input.executeFromDOM(this, event, scope);
    }
    async act_1014170467214631_script_7036_getActionArgs_value($event) {
        this.item.settings = this.settings;
    }
    async act_1014170467214631_script_7036_getActionArgs($event) {
        return {
            value: () => this.act_1014170467214631_script_7036_getActionArgs_value($event),
        };
    }
    async evh_1014170467214631_input(event, scope) {
        return await this.actions.evh_1014170467214631_input.executeFromDOM(this, event, scope);
    }
    async act_4664876391460503_script_7038_getActionArgs_value($event) {
        this.item.settings = this.settings;
    }
    async act_4664876391460503_script_7038_getActionArgs($event) {
        return {
            value: () => this.act_4664876391460503_script_7038_getActionArgs_value($event),
        };
    }
    async evh_4664876391460503_input(event, scope) {
        return await this.actions.evh_4664876391460503_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7024 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7023 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7024,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7023],
        });
        const act_8497951412896552_emit_7028 = new core_1.actions.EmitAction({
            actionArgs: this.act_8497951412896552_emit_7028_getActionArgs,
            events: [],
        });
        const evh_8497951412896552_success_7027 = new core_1.actions.EventHandlerImpl({
            action: act_8497951412896552_emit_7028,
            event: "success",
            displayName: "emit",
        });
        const act_8497951412896552_request_7026 = new core_1.actions.RequestAction({
            actionArgs: this.act_8497951412896552_request_7026_getActionArgs,
            displayName: "fetchTaxpayer",
            events: [evh_8497951412896552_success_7027],
        });
        const evh_8497951412896552_clickPreventStop_7025 = new core_1.actions.EventHandlerImpl({
            action: act_8497951412896552_request_7026,
            event: "click.prevent.stop",
            displayName: "fetchTaxpayer",
        });
        const evh_8497951412896552_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8497951412896552_clickPreventStop_7025],
        });
        const act_2014513287668498_script_7030 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2014513287668498_script_7030_getActionArgs,
            events: [],
        });
        const evh_2014513287668498_input_7029 = new core_1.actions.EventHandlerImpl({
            action: act_2014513287668498_script_7030,
            event: "input",
            displayName: "script",
        });
        const evh_2014513287668498_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2014513287668498_input_7029],
        });
        const act_1490259005804208_script_7032 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1490259005804208_script_7032_getActionArgs,
            events: [],
        });
        const evh_1490259005804208_input_7031 = new core_1.actions.EventHandlerImpl({
            action: act_1490259005804208_script_7032,
            event: "input",
            displayName: "script",
        });
        const evh_1490259005804208_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1490259005804208_input_7031],
        });
        const act_5501809153536538_script_7034 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5501809153536538_script_7034_getActionArgs,
            events: [],
        });
        const evh_5501809153536538_input_7033 = new core_1.actions.EventHandlerImpl({
            action: act_5501809153536538_script_7034,
            event: "input",
            displayName: "script",
        });
        const evh_5501809153536538_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5501809153536538_input_7033],
        });
        const act_1014170467214631_script_7036 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1014170467214631_script_7036_getActionArgs,
            events: [],
        });
        const evh_1014170467214631_input_7035 = new core_1.actions.EventHandlerImpl({
            action: act_1014170467214631_script_7036,
            event: "input",
            displayName: "script",
        });
        const evh_1014170467214631_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1014170467214631_input_7035],
        });
        const act_4664876391460503_script_7038 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4664876391460503_script_7038_getActionArgs,
            events: [],
        });
        const evh_4664876391460503_input_7037 = new core_1.actions.EventHandlerImpl({
            action: act_4664876391460503_script_7038,
            event: "input",
            displayName: "script",
        });
        const evh_4664876391460503_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4664876391460503_input_7037],
        });
        return {
            act_7315092382398562_reloadComponentData_7024,
            evh_7315092382398562_reload_7023,
            evh_7315092382398562_reload,
            act_8497951412896552_emit_7028,
            evh_8497951412896552_success_7027,
            act_8497951412896552_request_7026,
            evh_8497951412896552_clickPreventStop_7025,
            evh_8497951412896552_clickPreventStop,
            act_2014513287668498_script_7030,
            evh_2014513287668498_input_7029,
            evh_2014513287668498_input,
            act_1490259005804208_script_7032,
            evh_1490259005804208_input_7031,
            evh_1490259005804208_input,
            act_5501809153536538_script_7034,
            evh_5501809153536538_input_7033,
            evh_5501809153536538_input,
            act_1014170467214631_script_7036,
            evh_1014170467214631_input_7035,
            evh_1014170467214631_input,
            act_4664876391460503_script_7038,
            evh_4664876391460503_input_7037,
            evh_4664876391460503_input,
            fetchTaxpayer: act_8497951412896552_request_7026,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetCompanyGeneral.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetCompanyGeneral.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetCompanyGeneral.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetCompanyGeneral.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], FieldsetCompanyGeneral.prototype, "displayFetchByTaxNumber", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('displayFetchByTaxNumber'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetCompanyGeneral.prototype, "onDisplay_fetch_by_tax_number", null);
FieldsetCompanyGeneral = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetCompanyGeneral);
exports.default = FieldsetCompanyGeneral;
vue_property_decorator_1.Vue.component("FieldsetCompanyGeneral", FieldsetCompanyGeneral);
